<template>
  <div :class="$style.container">
    <div :class="$style.logoBox">
      <img src="@/assets/customs-logo-20260610.jpg" :class="$style.logo"/>
      <span v-if="host === '172.20.6.65'">測試</span>
    </div>
    <div :class="$style.title">
      <span>{{ $t('common.Carryingcashandnameless') }}</span>
      <div :class="$style.selectBox">
        <div :class="this.$store.state.language === 'cn' ? $style.select : $style.unSelect " @click="handleLanguage('cn')">繁</div>
        <div :class="this.$store.state.language === 'pr' ? $style.select : $style.unSelect " @click="handleLanguage('pr')">Pt</div>
        <div :class="this.$store.state.language === 'us' ? $style.select : $style.unSelect " @click="handleLanguage('us')">En</div>

      </div>
    </div>
    <router-view/>
    <el-dialog
      class="dialog"
      :visible.sync="showAboutme"
      width="60%">
      <template #title><span :class="$style.infoTitle">{{ $t('common.aboutus') }}</span></template>
      <div :class="$style.infoBox">
        <div :class="$style.info">
          <c-info type="2"/>
        </div>
        <el-button :class="$style.close" type="primary" @click="showAboutme = false">{{ $t('common.OK') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog"
      :visible.sync="showCallme"
      width="60%">
      <template #title><span :class="$style.infoTitle">{{ $t('common.Contactus') }}</span></template>
      <div :class="$style.infoBox">
        <div :class="$style.info">
          <c-info type="3"/>
        </div>
        <el-button :class="$style.close" type="primary" @click="showCallme = false">{{ $t('common.OK') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="dialog"
      :title="$t('common.Useandprivacypolicy')"
      :visible.sync="showOther"
      width="60%">
      <template #title><span :class="$style.infoTitle">{{ $t('common.Useandprivacypolicy') }}</span></template>
      <div :class="$style.infoBox">
        <div :class="$style.info">
          <c-info type="4"/>
        </div>
        <el-button :class="$style.close" type="primary" @click="showOther = false">{{ $t('common.OK') }}</el-button>
      </div>
    </el-dialog>
    <c-footer type="pc" @open="handleOpen"/>
  </div>
</template>

<script>
  import { Button, Dialog } from "element-ui";
  import Footer from "../../components/footer";
  import Info from "../../components/info";
  export default {
    name: "Pc",
    components: {
      "el-button": Button,
      "el-dialog": Dialog,
      "c-footer": Footer,
      "c-info": Info
    },
    props: {
    },
    data () {
      return {
        showAboutme: false,
        showCallme: false,
        showOther: false,
        host: location.host
      };
    },
    methods: {
      handleOpen (type) {
        switch (type) {
        case "aboutMe" : {
          this.showAboutme = true;
          break;
        }
        case "callMe" : {
          this.showCallme = true;
          break;
        }
        case "other" : {
          this.showOther = true;
          break;
        }
        }
      },
      handleLanguage (type) {
        this.$i18n.locale = type;
        this.$store.commit("changeLanguage", type);
      }
    },
    created () {
      if (localStorage.getItem("pageData") && JSON.parse(localStorage.getItem("pageData")).length !== 0) {
        this.$router.push({path: "/eDCBNI/Currency/List"});
      } else {
        this.$router.push({path: "/eDCBNI/Currency/List"});
      }
    }
  };
</script>

<style lang="scss" module src="./style.scss">
</style>

<style lang="scss">
.el-button--primary {
  background-color: #43a6df;
}
.dialog > .el-dialog {
  background: #f9f9ec;
}
</style>